import {
  Box,
  IconButton,
  Modal,
  Slide,
  Skeleton,
  Button,
} from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import EditQuickNote from "./EditQuickNote";
import DeleteNote from "./DeleteNote";
import ViewNote from "./ViewNote";
import { useAuth } from "../../contexts/AuthContext";
import { showCustomToast } from "../Misc/CustomToast";
import { Timestamp, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import CircularProgress from "@mui/material/CircularProgress";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { LanguageContext } from "../../context/LanguageContext";
import NotesContainerCompactMobileEditContent from "./compactMobile/NotesContainerCompactMobileEditContent";
import NotesContainerCompactMobileListItem from "./compactMobile/NotesContainerCompactMobileListItem";
import { getTitleForNoteType } from "./compactMobile/notesContainerCompactMobileHelpers";

function NotesContainerCompactMobile(props) {
  const { translate } = useContext(LanguageContext);
  const { isSkeleton } = props;
  const [openNoteModal, setOpenNoteModal] = useState(false);
  const [, setCurrentNoteType] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [noteContent, setNoteContent] = useState(props.noteContent || "");
  const [shiftStartRaw, setShiftStartRaw] = useState(
    props.shiftStartRaw || null
  );
  const [shiftEndRaw, setShiftEndRaw] = useState(props.shiftEndRaw || null);
  const [staff, setStaff] = useState(props.staff || "");
  const [effectiveDateTime, setEffectiveDateTime] = useState(
    props.effectiveDateTime || null
  );
  const [notInAttendance, setNotInAttendance] = useState(
    props.notInAttendance || ""
  );

  const [groupTopic, setGroupTopic] = useState(props.groupTopic || "");
  const [groupType, setGroupType] = useState(props.groupType || "");
  const [otherTypeGroupNote, setOtherTypeGroupNote] = useState(
    props.otherTypeGroupNote || ""
  );
  const [relationship, setRelationship] = useState(props.relationship || "");
  const [files, setFiles] = useState(props.files || []);
  const [fileUrls, setFileUrls] = useState(props.fileUrls || []);
  const [noteId, setNoteId] = useState(props.noteId || "");
  const [immigrationAppointment, setImmigrationAppointment] = useState(
    props.immigrationAppointment || ""
  );
  const [dischargeSwot, setDischargeSwot] = useState(props.dischargeSwot || "");
  const [newClients, setNewClients] = useState(props.newClients || "");
  const [medicalInfos, setMedicalInfos] = useState(props.medicalInfos || "");
  const [hospitalAppointment, setHospitalAppointment] = useState(
    props.hospitalAppointment || ""
  );
  const [residentialClientMovements, setResidentialClientMovements] = useState(
    props.residentialClientMovements || ""
  );
  const [zoomSessionAssistance, setZoomSessionAssistance] = useState(
    props.zoomSessionAssistance || ""
  );
  const [staffToday, setStaffToday] = useState(props.staffToday || "");
  const [overnight, setOvernight] = useState(props.overnight || "");
  const [numberOfClient, setNumberOfClient] = useState(
    props.numberOfClient || ""
  );
  const [swot, setSwot] = useState(props.swot || "");
  const [generalAnnouncement, setGeneralAnnouncement] = useState(
    props.generalAnnouncement || ""
  );

  const [groupStartDateTime, setGroupStartDateTime] = useState(
    props.groupStartDateTime || null
  );
  const [, setEffectiveDate] = useState(props.effectiveDate || null);

  const handleNoteContentChange = (event) => setNoteContent(event.target.value);
  const handleShiftStartRawChange = (date) => setShiftStartRaw(date);
  const handleShiftEndRawChange = (date) => setShiftEndRaw(date);
  const handleStaffChange = (staff) => setStaff(staff);
  const handleEffectiveDateTimeChange = (date) => setEffectiveDateTime(date);
  const handleNotInAttendanceChange = (event) =>
    setNotInAttendance(event.target.value);
  const handleGroupTopicChange = (event) => setGroupTopic(event.target.value);
  const handleGroupTypeChange = (type) => setGroupType(type);
  const handleOtherTypeGroupNoteChange = (event) =>
    setOtherTypeGroupNote(event.target.value);
  const handleRelationshipChange = (relationship) =>
    setRelationship(relationship);

  const [errors, setErrors] = useState({});

  const handleFilesChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.every((file) => file.size <= 50 * 1024 * 1024)) {
      // Vérifiez la taille du fichier (50 Mo)
      setFiles(selectedFiles);
    } else {
      alert("One or more files exceed the size limit of 50MB.");
    }
  };

  const handleFileRemove = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  // ...

  useEffect(() => {
    setNoteContent(props.noteContent || "");
    setShiftStartRaw(props.shiftStartRaw || null);
    setShiftEndRaw(props.shiftEndRaw || null);
    setStaff(props.staff || "");
    setEffectiveDateTime(props.effectiveDateTime || null);
    setNotInAttendance(props.notInAttendance || "");
    setGroupTopic(props.groupTopic || "");
    setGroupType(props.groupType || "");
    setOtherTypeGroupNote(props.otherTypeGroupNote || "");
    setRelationship(props.relationship || "");
    setFiles(props.files || []);
    setFileUrls(props.fileUrls || []);
    setNoteId(props.noteId || "");
    setImmigrationAppointment(props.immigrationAppointment || "");
    setDischargeSwot(props.dischargeSwot || "");
    setNewClients(props.newClients || "");
    setMedicalInfos(props.medicalInfos || "");
    setHospitalAppointment(props.hospitalAppointment || "");
    setResidentialClientMovements(props.residentialClientMovements || "");
    setZoomSessionAssistance(props.zoomSessionAssistance || "");
    setStaffToday(props.staffToday || "");
    setOvernight(props.overnight || "");
    setNumberOfClient(props.numberOfClient || "");
    setSwot(props.swot || "");
    setGeneralAnnouncement(props.generalAnnouncement || "");
    setGroupStartDateTime(props.groupStartDateTime || null);
    setEffectiveDate(props.effectiveDate || null);
  }, [props]);

  const validateFields = () => {
    const newErrors = {};
    switch (modalContent) {
      case "aftercareNote":
      case "medicalNote":
      case "quickNote":
      case "familyNote":
      case "supportStaffNote":
      case "therapyNote":
        if (!noteContent) newErrors.noteContent = "Content is required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date is required";
        if (!props.clientFirstName) newErrors.clientName = "Client is required";
        break;
      case "handoverNote":
        if (!generalAnnouncement)
          newErrors.generalAnnouncement = "General Announcement is required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date is required";
        break;
      case "groupNote":
        if (!groupTopic) newErrors.groupTopic = "Group Topic is required";
        if (!groupStartDateTime)
          newErrors.groupStartDateTime = "Start Time is required";
        if (!groupType) newErrors.groupType = "Group Type is required";
        if (!noteContent) newErrors.noteContent = "Content is required";
        if (!notInAttendance)
          newErrors.notInAttendance = "Clients Not Present is required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date is required";
        break;
      case "endOfShift":
        if (!noteContent) newErrors.noteContent = "Content is required";
        if (!shiftStartRaw)
          newErrors.shiftStartRaw = "Start of Shift is required";
        if (!shiftEndRaw) newErrors.shiftEndRaw = "End of Shift is required";
        if (!staff) newErrors.staff = "Staff is required";
        if (!effectiveDateTime)
          newErrors.effectiveDateTime = "Effective Date is required";
        break;
      default:
        break;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleOpenNoteModal = (noteType) => () => {
    setCurrentNoteType(noteType);
    setModalContent(noteType);
    setOpenNoteModal(true);
  };

  const uploadFilesAndGetUrls = async (noteId, files) => {
    if (!Array.isArray(files)) {
      return [];
    }

    const storage = getStorage();
    const uploadedFileUrls = [];

    for (const file of files) {
      const filePath = `Documents/familyNotes/${noteId}/${file.name}`;
      const storageRef = ref(storage, filePath);

      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      uploadedFileUrls.push({ url: fileUrl, name: file.name });
    }

    return uploadedFileUrls;
  };

  const deleteFile = async (fileUrl, fileName, noteId) => {
    try {
      showCustomToast("Demo version - modifications not allowed :)", "info");
    } catch (error) {
      console.log("Error deleting file:", error);
      showCustomToast("Error deleting file", "error");
    }
  };


  const handleSaveNote = async () => {
    setIsLoading(true);
    try {
      let noteData = {};
      const noteId = props.noteId;

      const getValidTimestamp = (date) => {
        return date instanceof Date && !isNaN(date)
          ? Timestamp.fromDate(new Date(date))
          : null;
      };

      switch (modalContent) {
        case "endOfShift":
          noteData = {
            noteContent,
            shiftStart: getValidTimestamp(shiftStartRaw),
            shiftEnd: getValidTimestamp(shiftEndRaw),
            staff,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "familyNote":
          const newFileUrls = await uploadFilesAndGetUrls(noteId, files);
          const updatedFileLinks = [...fileUrls, ...newFileUrls];
          noteData = {
            noteContent,
            effectiveDateTime: effectiveDateTime,
            relationship,
            // files,
            // fileUrls,
            fileUrls: updatedFileLinks,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "groupNote":
          noteData = {
            noteContent,
            groupTopic,
            groupStartDateTime: effectiveDateTime,
            groupType,
            otherTypeGroupNote,
            notInAttendance,
            effectiveDateTime: effectiveDateTime,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "handoverNote":
          noteData = {
            noteContent,
            immigrationAppointment,
            dischargeSwot,
            newClients,
            medicalInfos,
            hospitalAppointment,
            residentialClientMovements,
            zoomSessionAssistance,
            staffToday,
            overnight,
            numberOfClient,
            swot,
            generalAnnouncement,
            effectiveDateTime: effectiveDateTime,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "medicalNote":
          const newFileUrlsMedical = await uploadFilesAndGetUrls(noteId, files);
          const updatedFileLinksMedical = [...fileUrls, ...newFileUrlsMedical];
          noteData = {
            noteContent,
            effectiveDateTime: effectiveDateTime,
            // files,
            fileUrls: updatedFileLinksMedical,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "quickNote":
          noteData = {
            noteContent,
            effectiveDateTime: effectiveDateTime,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "therapyNote":
          noteData = {
            noteContent,
            effectiveDateTime: effectiveDateTime,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "supportStaffNote":
          noteData = {
            noteContent,
            effectiveDateTime: effectiveDateTime,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        case "aftercareNote":
          noteData = {
            noteContent,
            effectiveDateTime: effectiveDateTime,
            updatedBy: currentUser.displayName,
            updatedAt: Timestamp.now(),
          };
          break;
        default:
          throw new Error("Unknown note type");
      }

      const docRef = doc(db, "notes", noteId);
      await updateDoc(docRef, noteData);
      showCustomToast(
        `${modalContent
          .replace(/([A-Z])/g, " $1")
          .trim()} Note successfully updated!`,
        "success"
      );
      setOpenNoteModal(false);
      resetFiles();
      handleMenuClose();
    } catch (error) {
      console.error("Error updating note:", error);
      showCustomToast("Problem when updating note!", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNoteModal = () => {
    setOpenNoteModal(false);
    setModalContent(null);
    setFiles([]); // Réinitialiser l'état des fichiers
  };

  const resetFiles = () => {
    setFiles([]);
  };

  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 600,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };


  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const [shouldNavigate, setShouldNavigate] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const openEditModal = () => {
    setShowEditModal(true);
  };
  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };
  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const handleNavigate = () => {
    setShouldNavigate(true);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${props.clientId}`, {
        state: props,
      });
    }
  }, [shouldNavigate]);

  if (isSkeleton) {
    return (
      <div
        style={{
          width: "100%",
          height: "80px",
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid lightgrey",
          padding: "10px",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={80}
          height={80}
          style={{ marginRight: "15px" }}
        />
        <div style={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" height={30} />
          <Skeleton
            variant="text"
            width="80%"
            height={20}
            style={{ marginTop: 10 }}
          />
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <Modal
        open={openNoteModal}
        onClose={() => setOpenNoteModal(false)}
        aria-labelledby="note-modal-title"
        aria-describedby="note-modal-description"
        closeAfterTransition
      >
        <Slide direction="left" in={openNoteModal}>
          <Box
            sx={{
              position: "fixed",
              top: "5%",
              right: 0,
              width: "90%",
              height: "90%",
              bgcolor: "background.paper",
              boxShadow: 24,
              marginRight: "15px",
              pl: 0,
              pr: 0,
              borderRadius: "15px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
                borderBottom: "1px solid lightgray",
              }}
            >
              <div
                id="note-modal-title"
                style={{
                  margin: 0,
                  paddingLeft: "35px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  fontSize: "18px",
                  fontWeight: "700",
                }}
              >
                {getTitleForNoteType(modalContent, translate)}
              </div>
              <div style={{ paddingRight: "15px" }}>
                <IconButton
                  // onClick={() => setOpenNoteModal(false)}
                  onClick={handleCloseNoteModal}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </Box>
            <Box
              id="note-modal-description"
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                mt: 0,
                pl: 0.5,
                pr: 0.5,
              }}
            >
              <NotesContainerCompactMobileEditContent
                {...props}
                modalContent={modalContent}
                translate={translate}
                noteContent={noteContent}
                handleNoteContentChange={handleNoteContentChange}
                shiftStartRaw={shiftStartRaw}
                handleShiftStartRawChange={handleShiftStartRawChange}
                shiftEndRaw={shiftEndRaw}
                handleShiftEndRawChange={handleShiftEndRawChange}
                staff={staff}
                handleStaffChange={handleStaffChange}
                effectiveDateTime={effectiveDateTime}
                handleEffectiveDateTimeChange={handleEffectiveDateTimeChange}
                notInAttendance={notInAttendance}
                handleNotInAttendanceChange={handleNotInAttendanceChange}
                groupTopic={groupTopic}
                handleGroupTopicChange={handleGroupTopicChange}
                groupType={groupType}
                handleGroupTypeChange={handleGroupTypeChange}
                otherTypeGroupNote={otherTypeGroupNote}
                handleOtherTypeGroupNoteChange={handleOtherTypeGroupNoteChange}
                relationship={relationship}
                handleRelationshipChange={handleRelationshipChange}
                files={files}
                fileUrls={fileUrls}
                noteId={noteId}
                handleFilesChange={handleFilesChange}
                handleFileRemove={handleFileRemove}
                deleteFile={deleteFile}
                errors={errors}
                immigrationAppointment={immigrationAppointment}
                setImmigrationAppointment={setImmigrationAppointment}
                dischargeSwot={dischargeSwot}
                setDischargeSwot={setDischargeSwot}
                newClients={newClients}
                setNewClients={setNewClients}
                medicalInfos={medicalInfos}
                setMedicalInfos={setMedicalInfos}
                hospitalAppointment={hospitalAppointment}
                setHospitalAppointment={setHospitalAppointment}
                residentialClientMovements={residentialClientMovements}
                setResidentialClientMovements={setResidentialClientMovements}
                zoomSessionAssistance={zoomSessionAssistance}
                setZoomSessionAssistance={setZoomSessionAssistance}
                staffToday={staffToday}
                setStaffToday={setStaffToday}
                overnight={overnight}
                setOvernight={setOvernight}
                numberOfClient={numberOfClient}
                setNumberOfClient={setNumberOfClient}
                swot={swot}
                setSwot={setSwot}
                generalAnnouncement={generalAnnouncement}
                setGeneralAnnouncement={setGeneralAnnouncement}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                borderTop: "1px solid lightgray",
                padding: "10px 20px",
                mt: "auto",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: "10px" }}
                // onClick={() => setOpenNoteModal(false)}
                onClick={handleCloseNoteModal}
              >
                {translate("Cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveNote}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} /> : translate("Save")}
              </Button>
            </Box>
          </Box>
        </Slide>
      </Modal>

      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit}>
          <EditQuickNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeEditModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <ViewNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
          />
        </Box>
      </Modal>
      <NotesContainerCompactMobileListItem
        noteType={props.noteType}
        noteDate={props.noteDate}
        clientFirstName={props.clientFirstName}
        clientLastName={props.clientLastName}
        clientPic={props.clientPic}
        onOpen={handleOpenNoteModal(props.noteType)}
      />
    </div>
  );
}

export default NotesContainerCompactMobile;
